<script lang="ts">
  import type { HeroBannerProps } from '$lib/types/contentTypes';
  import Button from '$lib/components/control/Button.svelte';
  import { richTextFormatter } from '$lib/helpers/richTextHelper';

  export let heroBanner: HeroBannerProps;

  let textAlignment =
    heroBanner?.desktopTextAlignment === 'Left aligned'
      ? 'lg:text-left lg:w-1/2 lg:h-[40rem] lg:items-start'
      : 'text-center';

  let textColour =
    heroBanner?.textColour === 'White'
      ? 'text-white'
      : heroBanner?.textColour === 'Dark Grey'
        ? 'text-gray-800'
        : '';

  let mobileImage = heroBanner.backgroundMediaMobile
    ? heroBanner?.backgroundMediaMobile?.url
    : heroBanner?.backgroundMedia?.url;

  $: mobileBackgroundImageUrl = `${mobileImage}?w=780&q=85&fm=webp`;
  $: desktopBackgroundImageUrl = `${heroBanner?.backgroundMedia?.url}?w=1400&q=85&fm=webp`;
</script>

<svelte:head>
  <link
    rel="preload"
    as="image"
    type="image/webp"
    fetchpriority="high"
    href={mobileBackgroundImageUrl}
  />
</svelte:head>

<section
  class="w-full max-h-[90vh] h-[53.75rem] flex flex-col lg:justify-center items-center justify-end relative"
>
  <picture class="absolute w-full h-full">
    <source media="(max-width: 639px)" srcset={mobileBackgroundImageUrl} />
    <source media="(min-width: 640px)" srcset={desktopBackgroundImageUrl} />
    <img
      alt={heroBanner?.title}
      fetchpriority="high"
      loading="eager"
      class="w-full h-full object-cover object-top"
    />
  </picture>

  <div class="w-full px-4 text-center max-w-1280 flex flex-col lg:px-8 relative lg:mb-0 mb-[15vh]">
    <div class="{textAlignment} flex flex-col justify-center items-center">
      {#if heroBanner?.title}
        <h1
          class="text-display-md font-bold {textColour} mb-4 lg:text-display-2xl leading-[2.5rem] lg:leading-none lg:mt-4 [text-shadow:_1px_1px_0_rgba(0_0_0_/_40%)]"
          style="text-wrap: balance"
        >
          {heroBanner?.title}
        </h1>
      {/if}
      <div
        class="banner-description max-w-[48rem] [text-shadow:_1px_1px_0_rgba(0_0_0_/_40%)] tracking-[-0.02em]"
      >
        {@html richTextFormatter(heroBanner?.description, textColour)}
      </div>
      {#if heroBanner?.callToAction}
        <Button
          {...heroBanner?.callToAction}
          customClass="mt-8 plausible-event-name=hero_CTA_{heroBanner?.title?.split(' ').join('_')}"
        />
      {/if}
    </div>
  </div>
</section>

<style>
  .banner-description > * {
    font-size: 1.2rem !important;
  }
</style>
